module.exports = __webpack_public_path__ + "media/svg-new/paper-plane-b8fc6655.svg";